import React from "react";
import { useForm } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import { PrimaryButton } from "../../atoms/Buttons";

import loadIcon from "../../../assets/images/tail-spin.svg";

import { P } from "../../atoms/Texts";
import ModalHolder from "../../molecules/ModalHolder";
import { DarkSelectInput } from "../../atoms/Inputs";
import useCases from "../../../shared/hooks/useCases";
import { toastWarning } from "../../../shared/helpers";

const UpdateCaseStatusModal = ({ closeModal, _case }) => {
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();

  const onUpdateCaseStatus = (data) => {
    toastWarning("Cannot perform this action on Demo mode");
  };

  return (
    <ModalHolder closeModal={closeModal}>
      <section className="py-2 md:py-4">
        <form onSubmit={handleSubmit(onUpdateCaseStatus)} className="pb-10">
          <div className="">
            <DarkSelectInput
              type="select"
              id="status"
              name="status"
              {...register("status", {
                required: "Select a status",
              })}
              placeholder=""
              label="Status Name"
              defaultValue={_case?.status}
            >
              <option value="" disabled>
                Select Status
              </option>
              <option value="open">Open</option>
              <option value="closed">Closed</option>
            </DarkSelectInput>

            <ErrorMessage
              errors={errors}
              name="status"
              as={<P fontSize="12px" className="-mt-4 mb-4 text-red-400 text-sm" />}
            >
              {({ messages }) =>
                messages &&
                Object.entries(messages).map(([type, message]) => (
                  <P key={type}>{message}</P>
                ))
              }
            </ErrorMessage>
          </div>
          <div className="mt-8 flex justify-center">
            <PrimaryButton className="w-full">Save</PrimaryButton>
          </div>
        </form>
      </section>
    </ModalHolder>
  );
};

export default UpdateCaseStatusModal;
